/* global $:false */

// We use `object-fit` to contain images inside their parent element.
// That does nmot work on IE and not in Edge 12-15, see
// https://caniuse.com/#search=object-fit So we need some kind of
// fallback.

// Incidentally, we use the "padding-bottom hack" to maintain a square
// aspect ratio.  That means, our <img> always have `position:
// absolute`.  The JS below mimicks an object-fit-like behavior, it
// works only with absolutely positioned images.

import 'modernizr.js'

export default class IeAspectRatioImage {
  static init () {
    if (window.Modernizr.objectfit) { return }

    Array.from($('.js-ie-aspect-ratio-image')).map((el) =>
      new IeAspectRatioImage(el))
  }

  constructor (el) {
    this.el = $(el)
    this.adjustExpansion()
  }

  adjustExpansion () {
    const height = this.el[0].naturalHeight
    const width = this.el[0].naturalWidth

    if (height > width) {
      // This removes the `width: 100%`, which is needed for browsers
      // that support object-fit.  So, vertical images use up all
      // vertical space and adjust their width automatically.
      this.el.css({ width: 'auto' })
    }

    if (height < width) {
      this.el.css({ height: 'auto' })
    }
  }
}
